import { countryConfig } from '../country';

/**
 * The blurred stand-ins for a walled award — the winner with its company id,
 * and the winner's phone (see `BlurredValue`, rule 1: obviously fake once
 * un-blurred, every digit an 8).
 *
 * They are still TEXT in the page, so a crawler reads them unblurred. On Spain
 * that text was «ООО «Ххххххх Хххх» · 888888888» — a Russian company form and a
 * nine-digit Uzbek ИНН — on every /results row and walled lot, plus a +998
 * phone. Spain gets a Spanish-shaped fake instead: an S.L. with a CIF-shaped id
 * and a +34 number. Uzbekistan and Kazakhstan keep theirs byte for byte.
 */
const ES = countryConfig.code === 'es';
/** Chile: a SpA with a RUT-shaped id and a +56 celular — the same «every digit an 8». */
const CL = countryConfig.code === 'cl';

export const LOCKED_WINNER_PLACEHOLDER = ES
  ? 'Xxxxxxx Xxxx, S.L. · B88888888'
  : CL
    ? 'Xxxxxxx Xxxx SpA · 88888888-8'
    : 'ООО «Ххххххх Хххх» · 888888888';

export const LOCKED_PHONE_PLACEHOLDER = ES
  ? '+34 888 888 888'
  : CL
    ? '+56 8 8888 8888'
    : '+998 88 888-88-88';
